import * as React from "react";

export const IconTriangleDown = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="48" height="24" viewBox="0 0 48 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 0L24 24L48 0H0Z" fill="currentColor" />
  </svg>
);
